import React from "react";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaYoutube,
  FaInstagram,
  FaTelegramPlane,
} from "react-icons/fa";
import { FaThreads, FaXTwitter, FaWhatsapp } from "react-icons/fa6";
import { BASEURL } from "../../../utils/BaseUrl";
import axios from "axios";
import { useQuery } from "react-query";

const SocialMedia = () => {
  const { data } = useQuery({
    queryKey: "getallSoacilmedia",
    queryFn: () =>
      axios.get(`${BASEURL}social-media`).then((res) => {
        return res?.data;
      }),
  });

  return (
    <div className="grid grid-cols-8 gap-6 mr-5 lg:grid md:hidden sm:hidden max-sm:hidden">
      {data?.links?.map((v, i) => {
        return (
          <div key={i}>
            {v.status && (
              <p>
                <a href={v.url} target="_blank">
                  <span className=" text-deep-grey hover:text-speed-red">
                    {v?.platform?.toLowerCase() == "facebook" ? (
                      <FaFacebookF className="font-semibold text-lg w-5 h-5" />
                    ) : v?.platform?.toLowerCase() == "linkedin" ? (
                      <FaLinkedinIn className="font-semibold text-lg w-5 h-5" />
                    ) : v?.platform?.toLowerCase() == "youtube" ? (
                      <FaYoutube className="font-semibold text-lg w-5 h-5" />
                    ) : v?.platform?.toLowerCase() == "twitter" ? (
                      <FaXTwitter className="font-semibold text-lg w-5 h-5" />
                    ) : v?.platform?.toLowerCase() == "instagram" ? (
                      <FaInstagram className="font-semibold text-lg w-5 h-5" />
                    ) : v?.platform?.toLowerCase() == "telegram" ? (
                      <FaTelegramPlane className="font-semibold text-lg w-5 h-5" />
                    ) : v?.platform?.toLowerCase() == "threads" ? (
                      <FaThreads className="font-semibold text-lg w-5 h-5" />
                    ) : v?.platform?.toLowerCase() == "whatsapp" ? (
                      <FaWhatsapp className="font-semibold text-lg w-5 h-5" />
                    ) : (
                      ""
                    )}
                  </span>
                </a>
              </p>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default SocialMedia;
